'use strict';

var React = require('react'),
    Button = require('../atoms/Button'),
    Icon = require('../atoms/Icon'),
    CheckLink = require('../atoms/CheckLink'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ZineStampStatus = require('../constants/ZineStampStatus'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    getStampSegment = require('../utils/getStampSegment'),
    { PropTypes } = React;

var SubmitStampControl = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    zine: PropTypes.object.isRequired,
    fill: PropTypes.bool
  },

  getDefaultProps() {
    return {
      color: 'dark',
      fill: false,
    };
  },

  canEditZine: function () {
    return this.props.zine.canEdit;
  },

  getStampStateInZine: function () {
    var { stamp, zine } = this.props;

    if (stamp.zines.indexOf(zine.slug) > -1) {
      return ZineStampStatus.APPROVED;
    }

    if (stamp.pendingZines.indexOf(zine.slug) > -1) {
      return ZineStampStatus.PENDING;
    }

    return ZineStampStatus.INITIAL;
  },

  isInInitialState: function () {
    return this.getStampStateInZine() === ZineStampStatus.INITIAL;
  },

  isInPendingState: function () {
    return this.getStampStateInZine() === ZineStampStatus.PENDING;
  },

  isInApprovedState: function () {
    return this.getStampStateInZine() === ZineStampStatus.APPROVED;
  },

  render: function () {
    if (this.isInInitialState() || this.isInPendingState() && this.canEditZine()) {
      return (
        <Button onClick={this.handleAddClick}
                color={this.props.color}
                fill={this.props.fill}
                overlay={this.props.overlay}>
          <Icon name='plus'
                mode='stroke'
                size='xsmall' />
          {this.canEditZine() ? 'Add' : 'Submit'}
        </Button>
      );
    }

    if (this.isInPendingState()) {
      return (
        <Button color={this.props.color}
                fill={this.props.fill}
                overlay={this.props.overlay}
                disabled>
          <Icon name='clock'
                size='small'
                mode='stroke' />
          In Review...
        </Button>
      );
    }

    if (this.isInApprovedState()) {
      return (
        <CheckLink onClick={this.handleRemoveClick}
                   color='green'>
          Remove
        </CheckLink>
      );
    }
  },

  handleAddClick() {
    var { zine, stamp } = this.props;
    const stampSegment = getStampSegment(stamp);

    if (!zine.canEdit) {
      ZineActionCreators.submitStampToZine(zine.slug, stampSegment);
      return;
    }

    if (this.isInPendingState()) {
      ZineActionCreators.approveStampToZine(zine.slug, stampSegment);
    } else {
      ZineActionCreators.addStampToZine(zine.slug, stampSegment);
    }
  },

  handleRemoveClick() {
    var { zine, stamp } = this.props;
    const stampSegment = getStampSegment(stamp);

    if (this.isInPendingState()) {
      ZineActionCreators.rejectStampFromZine(zine.slug, stampSegment);
    } else {
      ZineActionCreators.removeStampFromZine(zine.slug, stampSegment);
    }
  }
});

module.exports = SubmitStampControl;



/** WEBPACK FOOTER **
 ** ./molecules/SubmitStampControl.jsx
 **/